<template>
  <l-modal :showing="showing" text="Add converted timeserie" icon="plus-square" color="bg-pastel-green-500" @close="close">
    <div class="w-full flex flex-col text-xs">
      <div class="w-full mb-4">        
        <b>Station</b><br>
        <l-select v-model="staSelection" class="text-xs" :data="stations" placeholder="Please select a station" :multiple="false" >
            <l-option v-for="i in stations" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
      </div>
      <div class="flex mb-4">
        <div class="w-full mr-4">        
          <b>Timeserie</b><br>
          <l-select v-model="addObj.oc_id" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
            <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Source</b><br>
          <l-select v-model="addObj.source" class="text-xs" :data="units" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in units" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Target</b><br>
          <l-select v-model="addObj.target" class="text-xs" :data="units" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in units" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full">        
          <b>Factor</b><br>
          <l-input v-model="addObj.factor" />
        </div>
      </div>
      
      <div class="flex w-full justify-between">
        <div>
          <l-button type="success" :disabled="!addObj.oc_id || !addObj.source || !addObj.target || !addObj.factor" @click="onSave">Add converted timeserie</l-button>&nbsp;
        </div>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox"


export default {
  name: "LLAdd",
  props: [
    "showing",
    "stations",
    "units"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption,
    LInfoBox
  },
  data() {
    return {
      addObj:{},
      staSelection: null,
    }
  },
  computed: {    
    timeseries() {
      const sel = this.stations.find(t => {
        return t.value == this.staSelection;
      });
      this.addObj = {};
      if (!sel) return [];
      
      return sel.timeseries;
    }
  },
  methods: {
    close() {
      this.staSelection = null;
      this.addObj = {}; 
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", this.addObj);
      this.close();
    },
  }
};
</script>